import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BpgEventsService } from 'src/app/bpg-events/bpg-events.service'
import { ConstantValues } from 'src/app/bpg-common/models/bpg-constants';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { SelfService } from '../../bpg-self-services/self-services.service.ts';
import { Router } from '@angular/router';
import { BpgCommonService } from '../../bpg-common/services/bpg-common.service';
import { UploadService } from 'src/app/bpg-self-services/d-i/upload.service';
import { fireEvent } from 'highcharts';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-push-notification',
  templateUrl: './push-notification.component.html',
  styleUrls: ['./push-notification.component.css']
})
export class PushNotificationComponent implements OnInit {
  @ViewChild('callAPIDialog', { static: false }) callAPIDialog: TemplateRef<any>;
  adminId: any;
  loginDetails: any;
  loginData = JSON.parse(localStorage.getItem('loginData'));
  timeoutErrorMessage: string = ConstantValues.timeoutErrorMessage;
  timeOutError: boolean = false;
  selectedChapter: any;
  chapterNotification: string = '';
  chapterList: any = []
  method: string;
  param: string;
  msg1: string;
  notificationSuccess: boolean = false;
  notificationFailure: boolean = false;
  errorMsg: any;
  selectedFile: File = null;
  fileName: string = "Upload document(< 500MB)";
  fileExtensionError: boolean = false;
  fileSizeExtensionError: boolean = false;
  fileSize: number;
  fileExtension: any;
  fileUploadSuccess: boolean;
  chapterNotificationSuccess: boolean;
  base64textString: any;
  fileHeight: any;
  fileWidth: any;
  awsUrls: any;
  fileList: any = [];
  fileListName: any = [];
  removeToolbarHeaders: any = { disableNativeSpellChecker: false, autoParagraph: false, toolbar: 'Basic', extraPlugins: 'colorbutton', uiColor: '#FFFFFF', basicEntities: false, fillEmptyBlocks: false, removeButtons: 'Source,Save,NewPage,Preview,Print,Templates,Pasteas plain text,PastefromWord,Find,Replace,SelectAll,Form,Checkbox,Radio,TextField,Textarea,SelectionField,Button,ImageButton,HiddenField,Decrease,Increase,Block,Create Div Container,Text direction from left to right,Text direction from right to left,Set language,Image,Flash,Table,Horizontal,Smiley,Insert Special Character,Insert Page Break for Printing,IFrame,Formatting,Paragraph,Font,FontSize,Maximize,ShowBlocks,About,forceSpellChecker,Cut,Copy,Paste,Undo,Redo,Strike,Subscript,Superscript,RemoveFormat', height: '250px', maxLength: '2000', Backgroundcolor: 'black !important' };
  selectedfileName: string;
  siteList: any;
  bpgList: any;
  userAndRoleIdDTO: any;

  selectedBpgsData: any;
  selectedSiteIds: any = [];
  bpgId: any;
  allSiteIds: any;
  allBpgIds: any;
  bpgValue: any;
  siteId: any;
  subject: string
  emailList: any = [];
  memberUserId: any = [];
  selectedEmail: any = [];
  copySuccess: boolean = false;
  searchTerm: any;
  search: boolean;
  userList: any;
  noUser: boolean;
  userFound: boolean;
  selectedUserList: any = [];
  selectedEmailString: string = '';
  userFirstName: string;
  userExists: boolean;
  usersAdded: boolean;
  filterList: any;
  showCustomDateRange: boolean = false;
  startDate: any;
  endDate: any;
  selectedFilter: any;
  todaysDate: any = new Date();
  maxDate: any = new Date();
  showJoinedDateField: boolean = false
  countOfSignedUser: number = 10
  numberOfElements: number;
  currentPage: number = 0;
  limit: number = ConstantValues.pageLimit;
  totalPages: number = 0;
  noMemberFound: boolean = false;
  currentShowingElements: number = ConstantValues.pageLimit;
  startDateGreaterError: boolean = false;
  isbpgAdmin: boolean = false;
  isbpgLeadAdmin = false;
  constructor(private bpgEventsService: BpgEventsService,
    private spinner: Ng4LoadingSpinnerService,
    private router: Router,
    private environment: EnvironmentConfiguration,
    private datePipe: DatePipe,
    private selfService: SelfService,
    private bpgCommonService: BpgCommonService,
    private dialog: MatDialog,
    private uploadService: UploadService) { }

  ngOnInit() {
    if (this.environment.envName == 'dev' || this.environment.envName == 'qa' || this.environment.envName == 'prod') {
      if (localStorage.getItem('loginData') == null || localStorage.getItem('loginData') == undefined) {

        this.router.navigate(['/log-out']);
      }
    }

    this.adminId = localStorage.getItem('adminId');
    this.loginDetails = JSON.parse(localStorage.getItem("loginData"));
    if(localStorage.getItem('isbpgAdmin') == 'true')
    {
      this.isbpgAdmin = true
}
     if(localStorage.getItem('isbpgLeadAdmin') === 'true')   
     {
        this.isbpgLeadAdmin = true
     }
    if (this.adminId !== "1" && this.adminId !== "2" && this.adminId !== "3" && !this.isbpgAdmin && !this.isbpgLeadAdmin) {
      this.router.navigate(['/site-home']);
    }
    // if (this.loginDetails == null) {
    //   this.router.navigate(['/login']);
    // }
    this.loginData = JSON.parse(localStorage.getItem('loginData'));

    this.userAndRoleIdDTO = {
      userId: this.loginData['userId'],
      roleId: localStorage.getItem('adminId')
    }
    this.bpgCommonService.getSessionToken();

    if (this.chapterNotification != null && this.chapterNotification != undefined && this.chapterNotification != '') {
      this.chapterNotificationSuccess = true

    }
    if (this.chapterNotification == null || this.chapterNotification == undefined || this.chapterNotification == '') {
      this.chapterNotificationSuccess = false
    }
    this.filterList =
      [{ filterId: 1, filterName: 'All' },
      { filterId: 2, filterName: 'Custom Date Range' },
      { filterId: 3, filterName: 'Last 7 days' },
      { filterId: 4, filterName: 'Last 30 days' },
      { filterId: 5, filterName: 'Last 6 Months' },
      { filterId: 6, filterName: 'Last 12 Months' }];
    //this.getAllChapters()
    this.getAllBpg()
  }

  getAllBpg() {
    let landingDto = {
      "filter": {},
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "",
      "uid": ""
    };
    this.selfService.getAllBpg(landingDto).subscribe(data => {
      this.bpgList = data;
    })
  }


  /** For fetching site list
  * @class PushNotificationComponent
  * @method siteChange
  */
  public bpgChange(event) {
    this.selectedEmail = [];
    this.selectedFilter = 1;
    this.startDate = null;
    this.endDate = null;
    this.noMemberFound = false;
    this.copySuccess = false
    this.selectedSiteIds = [];
    this.memberUserId = [];
    this.emailList = [];
    this.siteId = null;
    this.siteList = [];
    if (event != undefined) {
      this.bpgId = event.bpgId;
    }
    this.selectedBpgsData =
    {
      "filter": {
        "bpgId": this.bpgId,
        "userId": this.userAndRoleIdDTO.userId,
        "adminId": this.userAndRoleIdDTO.roleId
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
    this.siteList = []
    this.bpgCommonService.getMySiteList(this.selectedBpgsData).subscribe(data => {
      this.siteList = data;
      this.siteList.unshift({ siteId: 0, siteName: 'Select All' });
      for (let i = 0; i < this.siteList.length; i++) {
        if (i == 0) {
          this.allSiteIds = this.siteList[i].siteId;
        } else {
          this.allSiteIds = this.allSiteIds + this.siteList[i].siteId + ",";
        }
      }
    });
  }
  siteChange(e) {
    this.noMemberFound = false;
    this.copySuccess = false
    for (let i = 0; i < e.length; i++) {
      if (e[i].siteId == 0 && e[i].siteName == 'Select All') {
        this.siteId = [];
        this.siteId = this.siteList
        this.siteId = this.siteId.filter(m => m.siteName != 'Select All');
        break
      }
    }
    if (this.siteId != null && this.bpgId != null && this.siteList.length > 0) {
      this.selectedSiteIds = [];
      if (this.siteId.length > 0) {
        for (var i = 0; i < this.siteId.length; i++) {
          this.selectedSiteIds.push(this.siteId[i].siteId);
        }
      }

      this.getChapterMembersEmails();
    }
  }
  getChapterMembersEmails() {

    this.noMemberFound = false;
    this.startDateGreaterError = false;

    if (this.selectedFilter == 2 && this.startDate == null && this.endDate == null) {
      {

        this.showCustomDateRange = true;
        this.emailList = []

      }


    }
    else if (this.selectedFilter == 2 && this.startDate != null && this.endDate != null && this.endDate < this.startDate) {
      this.startDateGreaterError = true
    }
    else {
      if (this.showJoinedDateField) {
        this.spinner.show();
        if (this.selectedFilter != 2 || (this.selectedFilter == 2 && this.startDate != null && this.endDate != null)) {
          if (this.selectedFilter != 2) {
            this.startDate = null;
            this.endDate = null;
            this.showCustomDateRange = false
          }

        }

      }
      if (this.showJoinedDateField == false) {
        this.selectedFilter = 0;
        this.startDate = null;
        this.endDate = null;
      }

      this.allSiteIds = this.selectedSiteIds.toString();
      if (this.selectedFilter == 2 && this.startDate != null && this.endDate != null) {
        // this.startDate = this.startDate.toString()
        // this.startDate= this.datePipe.transform(this.startDate,'yyyy-MM-dd');
        // this.endDate= this.datePipe.transform(this.endDate,'yyyy-MM-dd');
      }
      this.selectedBpgsData =
      {
        "filter": {
          "bpgId": this.bpgId,
          "userId": 0,
          "siteId": this.allSiteIds,
          "filterId": this.selectedFilter,
          'startDate': this.startDate,
          'endDate': this.endDate
        },
        "moduleId": 0,
        "page": 0,
        "presentRole": "string",
        "searchTerm": "string",
        "size": 0,
        "sortDirection": "ASC",
        "sortProperty": "string",
        "uid": "string"
      }




      this.bpgCommonService.getChapterEmailList(this.selectedBpgsData).subscribe(data => {
        this.spinner.hide();
        this.emailList = []
        this.selectedEmail = []
        this.emailList = data;
        if (this.emailList != null && this.emailList != undefined) {


          this.noMemberFound = false;
          this.selectedEmail = []
          if (this.emailList.length > 0) {
            // this.emailList.unshift({ userId: 0, emailId: 'Select All' });
            for (let i = 0; i < this.emailList.length; i++) {
              if (this.emailList[i].emailId)
                this.selectedEmail.push(this.emailList[i].emailId)
            }
          }

        }
        else {
          this.noMemberFound = true;
        }

      });
    }
  }

  sendEmail() {
    this.selectedEmailString = '';
    console.log(this.selectedEmail.length)
    for (let i = 0; i < this.selectedEmail.length; i++) {
      if (i == 0 && this.selectedEmail.length == 1) {
        this.selectedEmailString = this.selectedEmail[i]
      }
      else if (i == 0 && this.selectedEmail.length > 1) {
        this.selectedEmailString += this.selectedEmail[i] + ','
      }
      else if (i != this.selectedEmail.length - 1 && i != 0) {
        this.selectedEmailString += this.selectedEmail[i] + ','
      }

      else {
        this.selectedEmailString += this.selectedEmail[i]
      }

    }
    window.location.assign("mailto:" + this.selectedEmailString);
  }
  copyText() {
    this.selectedEmailString = '';
    this.copySuccess = true;
    for (let i = 0; i < this.selectedEmail.length; i++) {
      if (i == 0 && this.selectedEmail.length == 1) {
        this.selectedEmailString = this.selectedEmail[i]
      }
      else if (i == 0 && this.selectedEmail.length > 1) {
        this.selectedEmailString += this.selectedEmail[i] + ';'
      }
      else if (i != this.selectedEmail.length - 1 && i != 0) {
        this.selectedEmailString += this.selectedEmail[i] + ';'
      }

      else {
        this.selectedEmailString += this.selectedEmail[i]
      }
    }
     navigator.clipboard.writeText(this.selectedEmailString);
  }

  showJoinedDateFilter() {
    this.startDateGreaterError = false;
    this.showJoinedDateField = !this.showJoinedDateField;
    this.selectedFilter = 1
  }

  emailChange(e) {
    // this.copySuccess = false
    for (let i = 0; i < e.length; i++) {
      if (e[i].userId == 0 && e[i].emailId == 'Select All') {
        this.selectedEmail = [];
        this.selectedEmail = this.emailList
        this.selectedEmail = this.selectedEmail.filter(m => m.emailId != 'Select All');

        break
      }
    }
  }
  removeText() {
    this.selectedEmail = [];
    this.emailList = [];
  }

  openAndCloseMatDialog(type) {
    if (type == 'open') {
      this.usersAdded = false;
      this.userExists = false;

      const dialogConfig = new MatDialogConfig();
      dialogConfig.height = "70vh";
      dialogConfig.width = "60vw";
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = false;
      const dialogRef = this.dialog.open(this.callAPIDialog, dialogConfig);
      dialogRef.updatePosition({
        bottom: '5vh',
        // right:'0'
      })
    }

    else {
      this.userFound = false;
      this.searchTerm = null;
      this.userList = []
      this.copySuccess = false
      this.selectedUserList = [];
      this.userExists = false;
      this.usersAdded = false;
      this.userFirstName = ''
      const dialogConfig = new MatDialogConfig();
      const dialogRef = this.dialog.closeAll();

    }

  }
  searchBy() {
    //this.deleteSuccess = false;

    // this.clearError();
    // this.spinner.show(); 
    this.userExists = false

    this.search = true;
    this.searchTerm = (this.searchTerm) ? this.searchTerm : '';
    //this.landingDto.searchTerm = this.searchTerm;
    this.getUserList();
    //this.spinner.hide();   
  }
  /** to list users other than admins
* @class AdminComponent
* @method getUserList
*/

  getUserList() {
    this.timeOutError = false;
    this.selectedBpgsData =
    {
      "filter": {
        "leadershipPosition": "USER"
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": this.searchTerm,
      "size": 10,
      "sortDirection": "ASC",
      "sortProperty": "um.user_first_name",
      "uid": "string"
    }

    this.selfService.getUserDropDown(this.selectedBpgsData).subscribe(data => {
      this.userList = data;
      if (this.userList.length == 0) {
        setTimeout(() => {
          window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 500);
        this.noUser = true;
        this.userFound = false;
        // if(this.deleteSuccess == true  ){
        //   this.noUser = false;
        // }
      } else {
        if (this.search) {
          setTimeout(() => {
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
          }, 500);
          this.userFound = true;
          this.noUser = false;
        }
        this.userList.map((i) => { i.userFirstName = i.userFirstName + ' ' + i.userLastName; return i; })
      }


    }, err => {
      console.log(JSON.stringify(err.value.message));
      if (err.value.statusText == ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });
  }
  userSelection($event) {
    this.userExists = false;
    this.userFound = false;
    this.searchTerm = '';
    var index = this.emailList.indexOf($event);
    var index1 = this.selectedEmail.indexOf($event.emailId);
    var index2 = this.selectedUserList.indexOf($event);

    if (index === -1 && index1 === -1 && index2 == -1) {

      // val not found, pushing onto array

      this.selectedUserList.push($event)
      this.search = false;

    } else {

      this.userExists = true
      this.userFound = false

    }

  }


  removeUser(emailId) {
    var index = this.selectedUserList.indexOf(emailId);
    this.selectedUserList.splice(index, 1);
    this.search = false;
  }


  resetSelectedUser() {

    this.selectedUserList = [];
    this.userFound = false;
    this.searchTerm = null;
    this.userList = null;
    this.userFirstName = '';
    this.search = false;
    this.userExists = false;
    this.startDate = null;
    this.endDate = null;
    this.selectedFilter = null;
  }
  addUserToList() {
    this.userExists = false
    this.method = "addUsersToEmailList";
    this.param = '';
    this.msg1 = 'Are you sure you want to add the Selected User(s) to "Email To List"?'

  }
  addUsersToEmailList() {

    for (let i = 0; i < this.selectedUserList.length; i++) {
      this.emailList = [...this.emailList, { userIid: this.selectedUserList[i].userId, emailId: this.selectedUserList[i].emailId }];
      this.selectedEmail = [...this.selectedEmail, this.selectedUserList[i].emailId]
    }
    this.openAndCloseMatDialog('close');
    this.usersAdded = true;
    this.noMemberFound = false;

  }
  // getAllChapters() {
  //   this.spinner.show()
  //   var landingData = {
  //     "filter": {},
  //     "moduleId": 0,
  //     "page": 0,
  //     "presentRole": "string",
  //     "searchTerm": "string",
  //     "size": 0,
  //     "sortDirection": "DESC",
  //     "sortProperty": 'chapter_id',
  //     "uid": "string"

  //   }
  //   this.selfService.getAllChapter(landingData).subscribe(data => {
  //     if (data != null && data != undefined) {
  //       this.spinner.hide()
  //       this.chapterList = data;
  //       for (let i = 0; i < this.chapterList.length; i++) {
  //         this.chapterList[i].chapterName = this.chapterList[i].siteName + '-' + this.chapterList[i].bpgName

  //       }

  //     }
  //   }
  //   );
  // }


  /** checks if word exists in array
  * @class ConfigureGalleryComponent
  * @method isInArray
  */
  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }
  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.base64textString = btoa(binaryString);

  }

  deleteFile(d) {
    var index = this.fileList.indexOf(d);
    this.fileList.splice(index, 1);
    this.fileListName = [];
    this.fileName = ''
    if (this.fileList.length == 0) {
      this.fileName = "Upload < 500MB";
    }
    if (this.fileList.length > 0) {
      this.fileSize = 0;

      for (var i = 0; i < this.fileList.length; i++) {

        this.fileSize += this.fileList[i].size;
        if (this.fileSize > 524288000) {
          this.fileSizeExtensionError = true;
        } else {


          this.fileListName.push(this.fileList[i].name);
          if (this.fileList.length == 1) {
            this.fileName = this.fileList[i].name
          }
          else {
            this.fileName = this.fileName + " , " + this.fileList[i].name
          }
        }
      }
    }

  }

  /** For capturing files detail
* @class PushNotificationComponent
* @method onFileSelected
*/
  public onFileSelected(event) {
    this.fileExtensionError = false;
    this.fileSizeExtensionError = false;
    this.selectedfileName = "";
    if (event.target.files.length > 0) {
      for (var i = 0; i < event.target.files.length; i++) {
        this.selectedfileName = event.target.files[i].name;
        this.fileSize += event.target.files[i].size;
        var allowedExtensions = ["jpg", "jpeg", "png", "pdf", "ppt", "pptx", "txt", "doc", "docx", "xlsx", "csv"];
        this.fileExtension = this.selectedfileName.split('.').pop();
        if (this.isInArray(allowedExtensions, this.fileExtension)) {
          if (this.fileSize > 524288000) {
            this.fileSizeExtensionError = true;
          } else {
            this.fileExtensionError = false;
            this.fileSizeExtensionError = false;
            this.selectedFile = <File>event.target.files[i];
            this.fileList.push(this.selectedFile);
            this.fileListName.push(this.selectedFile.name);
            if (this.fileList.length == 1) {
              this.fileName = this.selectedfileName;
            }
            else {
              this.fileName = this.fileName + " , " + this.selectedfileName;
            }
          }
        } else {
          this.fileExtensionError = true;
          // this.fileName = "Upload < 500MB";
        }
      }
    }
  }


  /**To reset notification
 * @class PushNotificationComponent
 * @method resetClick
 */
  resetClick() {
    this.method = "resetClickConfirmation";
    this.param = '';
    this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
  }

  /**To reset notification on confirmation
* @class PushNotificationComponent
* @method resetClickConfirmation
*/
  resetClickConfirmation() {
    this.startDateGreaterError = false;
    this.noMemberFound = false;
    this.copySuccess = false;
    this.bpgId = null;
    this.chapterNotification = '';
    this.subject = '';
    this.fileName = "Upload document(< 500MB)";
    this.selectedFile = null;
    this.fileList = [];
    this.fileSize = 0;
    this.fileExtensionError = false;
    this.fileSizeExtensionError = false;
    this.notificationSuccess = false;
    this.notificationFailure = false;
    this.selectedSiteIds = [];
    this.siteId = null;
    this.siteList = [];
    this.errorMsg = '';
    this.selectedEmail = [];
    this.emailList = [];
    this.spinner.hide()
  }

  /**To send Notification
* @class PushNotificationComponent
* @method sendNotification
*/
  sendNotification() {
    this.method = "onsendNotification";
    this.param = '';
    this.msg1 = " Are you sure you want to send notification ? ";
  }
  /**To send Notification on confirmation
* @class PushNotificationComponent
* @method onsendNotification
*/
  onsendNotification() {
    this.spinner.show();
    this.copySuccess = false;
    if (this.siteId.length > 0) {
      for (var i = 0; i < this.siteId.length; i++) {
        this.selectedSiteIds.push(this.siteId[i].siteId);
      }
    }

    if (this.selectedFile == null && this.fileName == "Upload document(< 500MB)") {
      this.fileName = ""
    }
    let notificationData = {
      "userId": this.loginDetails.userId,
      "notificationDesc": this.chapterNotification,
      "siteId": this.selectedSiteIds,
      "bpgId": this.bpgId,
      "fileNameList": this.fileListName,
      "subject": this.subject,
      "serviceFunction": 'saveData',
      "emailIdTo": this.selectedEmail.toString()
    }
    this.selfService.sendChapterNotification(notificationData).subscribe(data => {
      if (this.fileName == '') {
        this.fileName = "Upload document(< 500MB)"
      }
      if (data.message) {
        this.errorMsg = data.message
        this.notificationSuccess = false
        this.notificationFailure = true
        this.spinner.hide();
      }
      else if (data.body != null && data.body != undefined && this.fileList.length > 0) {
        for (let i = 0; i < this.fileList.length; i++) {
          var notificationId = data.body.notificationId
          let uploadFlag = 'chapter_notification'
          let uploadData =
          {
            'category': 'uploadDocument',
          }
          this.bpgCommonService.getAwsUrl(uploadData).subscribe(async data => {
            this.awsUrls = data;
            await this.uploadService.getPresignedUrl(this.fileList[i], this.awsUrls, Number(notificationId), uploadFlag);
            //console.log("errorUpl" + localStorage.getItem('uploadError'));
            if (localStorage.getItem('uploadError') == 'Error') {
              this.notificationSuccess = false
              this.notificationFailure = true
              this.errorMsg = 'Failed to send the notification'
              this.spinner.hide();
            }
            else if (i == this.fileList.length - 1 && localStorage.getItem('uploadError') != 'Error') {
              let notificationData = {
                "notificationId": notificationId,
                "serviceFunction": "savefile",
                "emailIdTo": this.selectedEmail.toString(),
                "siteId": this.selectedSiteIds,
                "bpgId": this.bpgId,
              }
              this.selfService.sendChapterNotification(notificationData).subscribe(data => {
                if (data.message) {
                  this.errorMsg = data.message
                  this.notificationSuccess = false
                  this.notificationFailure = true
                  this.spinner.hide();
                }
                else if (data.body != null && data.body != undefined) {
                  this.notificationSuccess = true
                  this.notificationFailure = false

                  if (this.notificationSuccess) {
                    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });

                    setTimeout(() => {
                      this.resetClickConfirmation();
                    }, 3000);

                  }
                }
              })
            }
          });
        }

      }
      else if (data.body != null && data.body != undefined && this.fileList.length == 0) {
        this.notificationSuccess = true
        this.notificationFailure = false

        if (this.notificationSuccess) {
          window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });

          setTimeout(() => {
            this.resetClickConfirmation();
          }, 3000);

        }
        //this.spinner.hide();
      }

    });
    // this.spinner.hide();
  }
}
